import {Modal} from 'antd'
import React from 'react'
import {renderSelf} from 'views/Shared'
import {BsEnvelopeCheck} from "react-icons/bs";

const createInfoDialog = ({
                              modal,
                              onOk,
                              title,
                              message,
                              translate = renderSelf,
                              ...props
                          }) => {

    (modal ?? Modal).info({
        icon: <BsEnvelopeCheck style={{color: '#38a169'}} className="anticon"/>,
        className: 'custom-modal',
        title: (
            <div className="font-bold text-green-700">
                {typeof title === "string" ? translate(title) : title}
            </div>
        ),
        content: (
            <div className="text-sm text-color-300 italic">
                {typeof message === "string" ? translate(message) : message}
            </div>
        ),
        onOk,
        ...props,
    })
}

export const showInfoDialog = ({
                                   onOk,
                                   title = 'are you sure',
                                   message = 'are you sure to continue executing?',
                                   translate = renderSelf,
                                   ...props
                               }) =>
    createInfoDialog({
        ...props,
        onOk,
        className: 'custom-modal text-base',
        title: typeof title === "string" ? translate(title) : title,
        message: typeof message === "string" ? translate(message) : message,
        okText: translate('got it'),
        cancelText: translate('cancel'),
        // okButtonProps: {
        //     type: 'text',
        //     className: 'button-rounded-md no-border font-medium text-sm text-color-300',
        // },
        // cancelButtonProps: {
        //     type: 'primary',
        //     className: 'button-rounded-md no-border',
        // },
    })

export default createInfoDialog
